import { RefObject, useEffect, useState } from 'react';

export default function useDropdown(
  ref: RefObject<HTMLElement | null>,
  initState: boolean,
): [boolean, React.Dispatch<React.SetStateAction<boolean>>] {
  const [isOpen, setIsOpen] = useState<boolean>(initState);

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (
        isOpen &&
        ref.current !== null &&
        !ref.current.contains(e.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      window.addEventListener('click', onClick);
    }

    return () => {
      window.removeEventListener('click', onClick);
    };
  }, [isOpen, ref]);

  return [isOpen, setIsOpen];
}
